import Commodity from "./commodity";

export default interface PositionGroup {
  id: number;
  name: string;
}

export interface CommodityPositionGroup {
  id: string;
  commodity: Commodity;
  positionGroup: PositionGroup;
}

export function getCommodityNameForPositionGroup(positionGroup: PositionGroup, commodityName: string): string {
  return positionGroup ? `${commodityName} - ${positionGroup.name}` : commodityName;
}

export function getPositionNameForPositionGroup(positionGroup: PositionGroup, positionName: string): string {
  return positionGroup ? `${positionName} - ${positionGroup.name}` : positionName;
}